import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Ref, useCallback, useEffect, useRef } from 'react';
import { assignRef, startIconDriftIfAllowed, stopIconDrift, TILT_CARD_DESKTOP_MQ } from '@/components/service-pages/TiltCardsGrid/Card/utils';
import { TiltCardsGridCardDto } from '@/components/service-pages/TiltCardsGrid/types';
import { Typography } from '@/components/shared/Typography';
import { useIntersectionCallbacks } from '@/hooks/useIntersectionCallbacks';
import css from './style.module.scss';
interface CardProps extends TiltCardsGridCardDto {
  iconName: 'green' | 'silver' | 'sexy' | 'nice' | 'fancy' | 'black';
  ref?: Ref<HTMLDivElement>;
}
const Card = t0 => {
  const $ = _c(17);
  const {
    title,
    text,
    iconName,
    ref
  } = t0;
  const iconRef = useRef(null);
  const cardRootRef = useRef(null);
  const isCardInViewRef = useRef(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [cardRootRef];
    t2 = {
      onEntry: () => {
        isCardInViewRef.current = true;
        startIconDriftIfAllowed(iconRef, isCardInViewRef);
      },
      onLeave: () => {
        isCardInViewRef.current = false;
        stopIconDrift(iconRef);
      }
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useIntersectionCallbacks(t1, t2);
  let t3;
  if ($[2] !== ref) {
    t3 = node => {
      cardRootRef.current = node;
      assignRef(ref, node);
    };
    $[2] = ref;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setCardRef = t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const mql = window.matchMedia(TILT_CARD_DESKTOP_MQ);
      const onBreakpoint = () => {
        if (mql.matches) {
          startIconDriftIfAllowed(iconRef, isCardInViewRef);
        } else {
          stopIconDrift(iconRef);
        }
      };
      mql.addEventListener("change", onBreakpoint);
      return () => mql.removeEventListener("change", onBreakpoint);
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = `/assets/images/website-prod-page/production-sauce/chub-${iconName}.webp`;
  let t7;
  if ($[6] !== t6) {
    t7 = <Image ref={iconRef} className={css.icon} src={t6} width={85} height={64} alt="" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== title) {
    t8 = <Typography variant="h6" tag="h3" className={css.title}>{title}</Typography>;
    $[8] = title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== text) {
    t9 = <Typography variant="body-m" tag="p" className={css.text}>{text}</Typography>;
    $[10] = text;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== setCardRef || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div ref={setCardRef} className={css.card}>{t7}{t8}{t9}</div>;
    $[12] = setCardRef;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default Card;